import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEn from './translations/en/common.json';
import companyDebitFormEn from './translations/en/companyDebitForm.json';
import damageReportEn from './translations/en/damageReport.json';
import formsEn from './translations/en/forms.json';
import generalFormEn from './translations/en/generalForm.json';
import generalPostInfoEn from './translations/en/generalPostInfo.json';
import myShipmentsEn from './translations/en/myShipments.json';
import newsletterFormEn from './translations/en/newsletterForm.json';
import openingHoursEn from './translations/en/openingHours.json';
import postboxPromoEn from './translations/en/postboxPromo.json';
import registerShipmentEn from './translations/en/registerShipment.json';
import searchEn from './translations/en/search.json';
import sendReceiptEn from './translations/en/sendReceipt.json';
import sendReceiptMultistepEn from './translations/en/sendReceiptMultistep.json';
import shipmentCalculatorEn from './translations/en/shipmentCalculator.json';
import trackShipmentEn from './translations/en/trackShipment.json';
import commonIs from './translations/is/common.json';
import companyDebitFormIs from './translations/is/companyDebitForm.json';
import damageReportIs from './translations/is/damageReport.json';
import formsIs from './translations/is/forms.json';
import generalFormIS from './translations/is/generalForm.json';
import generalPostInfoIs from './translations/is/generalPostInfo.json';
import myShipments from './translations/is/myShipments.json';
import newsletterForm from './translations/is/newsletterForm.json';
import openingHoursIs from './translations/is/openingHours.json';
import postboxPromoIs from './translations/is/postboxPromo.json';
import registerShipmentIs from './translations/is/registerShipment.json';
import searchIs from './translations/is/search.json';
import sendReceiptIs from './translations/is/sendReceipt.json';
import sendReceiptMultistepIs from './translations/is/sendReceiptMultistep.json';
import shipmentCalculatorIs from './translations/is/shipmentCalculator.json';
import trackShipmentIs from './translations/is/trackShipment.json';

const initI18Next = (language: string) => {
	i18n.use(initReactI18next).init({
		lng: language,
		fallbackLng: 'is',
		debug: true,
		interpolation: {
			escapeValue: false,
		},
		resources: {
			en: {
				common: commonEn,
				postboxPromo: postboxPromoEn,
				trackShipment: trackShipmentEn,
				registerShipment: registerShipmentEn,
				generalForm: generalFormEn,
				sendReceipt: sendReceiptEn,
				sendReceiptMultistep: sendReceiptMultistepEn,
				generalPostInfo: generalPostInfoEn,
				companyDebitForm: companyDebitFormEn,
				openingHours: openingHoursEn,
				search: searchEn,
				damageReport: damageReportEn,
				forms: formsEn,
				shipmentCalculator: shipmentCalculatorEn,
				myShipments: myShipmentsEn,
				newsletterForm: newsletterFormEn,
			},
			is: {
				shipmentCalculator: shipmentCalculatorIs,
				common: commonIs,
				postboxPromo: postboxPromoIs,
				trackShipment: trackShipmentIs,
				registerShipment: registerShipmentIs,
				sendReceipt: sendReceiptIs,
				sendReceiptMultistep: sendReceiptMultistepIs,
				generalPostInfo: generalPostInfoIs,
				generalForm: generalFormIS,
				companyDebitForm: companyDebitFormIs,
				openingHours: openingHoursIs,
				search: searchIs,
				damageReport: damageReportIs,
				forms: formsIs,
				myShipments: myShipments,
				newsletterForm: newsletterForm,
			},
		},
	});

	// @ts-ignore
	window.lang = language;
};

export default initI18Next;
